<div class="row" style="width: 40vw">
    <div mat-dialog-title class="col-12">Upload file</div>
    <div class="col-12">
        <div class="center">
            <ngx-file-drop dropZoneLabel="Drop files here" accept=".xls, .xlsx" (onFileDrop)="dropped($event)"
                dropZoneClassName="drop-area" contentClassName="drop-area-content">
                <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                    <div class="d-flex justify-content-center flex-column align-items-center py-4">
                        <p>Drag file</p>
                        <p>or</p>
                        <button mat-stroked-button type="button" (click)="openFileSelector()" class="d-block">Select file</button>
                    </div>
                </ng-template>
            </ngx-file-drop>
            <div class="upload-table">
                <table class="table">
                    <tbody class="upload-name-style">
                        <tr *ngFor="let item of files; let i=index">
                            <td>Uploaded: <strong>{{ item.relativePath }}</strong></td>
                        </tr>
                        <tr *ngIf="uploadError" class="text-error">
                            <td>{{uploadError}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- [disabled]="!fileReady" -->
            <div class="d-flex justify-content-center align-items-center">
                <button mat-stroked-button type="button" (click)="saveFile()" class="d-block my-0 confirm-btn">
                    <div class="d-flex justify-content-center align-items-center flex-column mt-2">
                        <i class="fas fa-arrow-right"></i>
                        Confirm
                    </div>
                </button>
                <mat-spinner *ngIf="isFileSelected && !fileReady" diameter="40" class="m-0 ml-2"></mat-spinner>
            </div>
        </div>
    </div>
</div>